/**
 * Formats a numeric value as currency
 * @param value - The numeric value to format (string or number)
 * @param currency - The currency code (default: 'USD')
 * @param isCents - Whether the input value is in cents (default: false)
 * @returns Formatted currency string
 */
export const formatCurrency = (
  value: string | number,
  currency = 'USD',
  isCents = false,
): string => {
  // Convert input to number, handling edge cases
  const numericValue = typeof value === 'number' ? value : Number(value)

  if (Number.isNaN(numericValue)) {
    return ''
  }

  // Convert from cents to dollars if needed
  const dollarsValue = isCents ? numericValue / 100 : numericValue

  return dollarsValue.toLocaleString('en-US', {
    style: 'currency',
    currency,
  })
}
